import React, { Component } from "react";
import PropTypes from "prop-types";
import Checkbox from "../Checkbox/Checkbox";

import "./CheckboxContainer.scss";

class CheckboxContainer extends Component {
  constructor(props) {
    super(props);
  }

  toggleSelection = e => {
    this.props.toggleSelection(e.target.id);
  };
  toggleAll = () => {
    this.props.toggleAll();
  };
  render() {
    const { checkboxItemsList } = this.props;
    let checkboxList = checkboxItemsList.map(item => {
      return (
        <Checkbox
          chLabelStyle="service-name-filter-checkbox"
          id={item.uniqueId ? item.uniqueId : item.code}
          checked={item.checked}
          label={item.label}
          onChange={this.toggleSelection}
        />
      );
    });
    return (
      <div>
        {this.props.showSelectAll ? (
          <Checkbox
            chLabelStyle="service-name-filter-checkbox"
            id="select-all"
            checked={false}
            label={"Select All"}
            onChange={this.toggleAll}
          />
        ) : (
          ""
        )}

        {checkboxList}
      </div>
    );
  }
}

export default CheckboxContainer;
